/**
 * ABテスト自動初期化エントリーポイント
 * data-ab-test属性を持つ全要素を検出して初期化
 * data-ab-fallback属性でフォールバックパターンを指定
 *
 * @example
 * ```html
 * <%= vite_javascript_tag 'pc/entrypoints/ab_test' %>
 *
 * <div data-ab-test="hero-design" data-ab-pattern="pattern-a" data-ab-fallback hidden>
 *   パターンA（フォールバック）
 * </div>
 * <div data-ab-test="hero-design" data-ab-pattern="pattern-b" hidden>
 *   パターンB
 * </div>
 * ```
 */
import { initAbTest } from '@/common/utils/abTestInit'

const initializeAllAbTests = async (): Promise<void> => {
  const elements = document.querySelectorAll('[data-ab-test]')

  const testConfigs = new Map<string, string | null>()
  elements.forEach((element) => {
    const testName = element.getAttribute('data-ab-test')

    if (testName !== null && testName !== '') {
      if (!testConfigs.has(testName)) {
        const hasFallback = element.hasAttribute('data-ab-fallback')
        if (hasFallback) {
          const fallbackPattern = element.getAttribute('data-ab-pattern')
          testConfigs.set(testName, fallbackPattern ?? null)
        } else {
          testConfigs.set(testName, null)
        }
      }
    }
  })

  await Promise.all(Array.from(testConfigs.entries()).map(async ([testName, fallbackPattern]) => await initAbTest(testName, fallbackPattern ?? '')))
}

document.addEventListener('DOMContentLoaded', () => {
  void initializeAllAbTests()
})
